import React from 'react';
import styles from './page1.scss';
import chart1 from './chart1.png';
import chart2 from './chart2.png';
import { getRem } from '../../func';

function Page1(props) {
  return (
    <div className={styles['page1']} ref={props.myRef}>
      <div className={styles['page1-main']}>
        <div className={styles['title']}>
          <div className={styles['left']}>TRENDING</div>

          <div className={styles['circle']}>1</div>

          <div className={styles['text']}>趋势</div>
        </div>

        <div className={`${styles.card} ${styles.card1}`}>
          <div className={styles['card1-number']}>1</div>

          <div className={styles['card1-main']}>
            <div className={styles['card1-title']}>{'趋势网'}</div>

            <div
              className={`${styles['card1-title']} ${styles.link}`}
              onClick={() => window.open('http://2019.wow-trend.com')}
            >
              {'wow-trend.com'}
            </div>

            <div className={styles['card-desc']} style={{ visibility: 'visible' }}>
              {'趋势网是WOW-TREND旗下推出的首款线上产品，从灵感趋势、色彩、成衣趋势、街拍、工艺等角度，提供符合本土市场行情的流行趋势资讯。同类产品有热点趋势小程序，便于用户随时随地获取最新趋势资讯。'}
            </div>
          </div>
        </div>

        <div className={`${styles.card} ${styles.card2}`}>
          <div className={styles['card-title']}>{'趋势&灵感'}</div>

          <div className={styles['card-desc']}>
            从宏观信息抓取到趋势演变研究，我们所提供的深度见解全部立足于本土市场，助力企业把握中国服装市场的创新和发展机遇。
          </div>

          <div className={styles['card-item-wrapper']}>
            <div className={styles['card-item']}>未来趋势</div>
            <div className={styles['card-item']}>电商趋势</div>
            <div className={styles['card-item']}>灵感情报</div>
            <div className={styles['card-item']}>市场趋势</div>
          </div>
        </div>

        <div className={`${styles.card} ${styles.card3}`}>
          <div className={styles['card-title']}>{'图集&视频'}</div>

          <div className={styles['card-desc']}>
            基于WOW-TREND的美学观点搜罗筛选，集萃全球艺术家、名人、古着图、市场实拍图、最新秀场视频及WOW-TREND原创印花、单品矢量图等有价值、有看点的高质量设计素材，助力用户设计和规划产品。
          </div>

          <div className={styles['card-item-wrapper']} style={{ width: getRem(390) }}>
            {
              ['灵感图库', '色彩图库', '市场实拍', '发布会', '城市街拍', '印花图库', '名人图片', '单品图库', '工艺图集', '单品矢量图', '品牌图集', '杂志', '订货会', '时装大片'].map(name => {
                return <div className={styles['card-item']}>{name}</div>;
              })
            }

            <div className={styles['card-item']} style={{ visibility: 'hidden' }}>{''}</div>

            <div className={styles['card-item']} style={{ width: '100%' }}>{'视频(秀场、原创、营销、工艺制作、名人)'}</div>
          </div>
        </div>

        <div className={`${styles.card} ${styles.card4}`}>
          <div className={styles['card-title']}>{'9+3产品类别'}</div>

          <div className={styles['card-desc']}>
            WOW - TREND团队致力对新兴潮流、消费趋势、工艺研发和消费者动向等资讯进行拆解及提炼，针对女装、男装、童装这3个频道分类，9种品类进行深度分析，确保用户精准掌握未来2年的时尚趋势。
          </div>

          <div className={styles['card4-row']}>
            <div className={styles['card4-row-name']}>3个频道:</div>
            <div className={styles['card4-row-item']}>女装</div>
            <div className={styles['card4-row-item']}>男装</div>
            <div className={styles['card4-row-item']}>童装</div>
          </div>

          <div className={styles['card4-row']}>
            <div className={styles['card4-row-name']}>9种品类:</div>
            {
              ['大衣', '连衣裙', '毛衫', '西装', '上衣', '皮草', '牛仔', '裤装', '羽绒'].map(item => {
                return <div key={item} className={styles['card4-row-item']}>{item}</div>;
              })
            }
          </div>

          <div className={styles['card4-chart']}>
            <div className={styles['chart-wrapper']}>
              <img src={chart1} />
            </div>
          </div>
        </div>

        <div className={styles['card5-wrapper']}>
          <div className={`${styles.card} ${styles.card5}`}>
            <div className={styles['card5-left']}>
              <div className={styles['card-title']}>{'分析&报告'}</div>

              <div className={styles['card-desc']}>
                我们提供即时更新的时尚新闻，深入研究品牌活动、零售、订货会、商品规划、市场营销和消费者等资讯，为用户提供最具落地化、多角度的趋势策略及务实性创意灵感。
              </div>

              <div className={styles['card-item-wrapper']} style={{ color: '#fff', width: getRem(400) }}>
                {
                  ['灵感/色彩分析', '消费者报告', 'T台/品牌/成衣趋势分析', '零售趋势报告', '街拍分析', '市场营销报告', '全球市场分析', 'T台/成衣/街拍大数据', '工艺细节/印花图案分析'].map(item => {
                    return <div key={item} className={styles['card-item2']}>{item}</div>;
                  })
                }
              </div>
            </div>

            <div className={styles['card5-right']}>
              <img src={chart2} />
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}

export default Page1;